import { regex } from './common'
export default regex('alpha40', /^[a-zñáéíóúA-zÑÁÉÍÓÚ ]{1,40}$/)